<template>
  <section class="" style="">
    <div class="container buscador" style="">
      <b-field id="tagInputField" :class="{ isFocused: focused }">
        <b-taginput
          v-model="tags"
          :data="filteredTags"
          v-on:add="selectCountry"
          v-on:focus="focused = true"
          v-on:blur="focused = false"
          v-on:remove="unselectCountry"
          autocomplete
          :allow-new="false"
          field="title"
          icon="magnify"
          :placeholder="$t('Ubicación de oportunidades de negocio').replace(/#/g, ' ')"
          @typing="getFilteredTags"
        >
        </b-taginput>
      </b-field>
    </div>
    <map-a
      ref="worldmap"
      v-on:mapClicked="addCountry"
      v-on:mapUnclicked="removeCountry"
    />
  </section>
</template>

<script>
import countries from '@/constants/countries.js'
import MapA from '@/components/on-board/D3Selector.vue'
import EnumeratesFormater from '@/mixins/enumeratesFormater.js'
import OnBoardStepMixin from '@/mixins/onBoardStepMixin.js'

export default {
  components: { MapA },
  mixins: [EnumeratesFormater, OnBoardStepMixin],
  data() {
    return {
      filteredTags: [],
      tags: [],
      selected: null,
      focused: false
    }
  },
  created: function() {
    this.filteredTags = this.formatWorldCountries(countries)
  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    let mapTooltip = document.getElementById('mapTooltip')
    if (mapTooltip) {
      mapTooltip.parentNode.removeChild(mapTooltip)
    }
    if (routeTo.name == 'onBoard.neofintech.phase1.3') {
      if (this.tags.length == 0) {
        this.$toast.open({
          duration: 5000,
          message: this.$t(`Debes seleccionar al menos un país`),
          position: 'is-bottom',
          type: 'is-danger'
        })
      } else {
        this.$store.commit(
          'onBoard/SET_NEOFINTECH_COUNTRIES',
          this.tags.map(function(item) {
            return item.id
          })
        )
        next()
      }
    } else {
      next()
    }
  },
  methods: {
    addCountry(country) {
      this.tags.push(country)
       this.$router.push({ name: this.$route.meta.next })
    },
    removeCountry(country) {
      this.tags = this.tags.filter(e => e.id !== country.id)
      this.$refs['worldmap'].unselectCountry(country.id)
    },
    selectCountry(country) {
      this.$refs['worldmap'].selectCountry(country.id)
    },
    unselectCountry(country) {
      this.$refs['worldmap'].unselectCountry(country.id)
    },
    getFilteredTags(text) {
      this.filteredTags = this.formatWorldCountries(countries).filter(
        option => {
          return (
            option['title']
              .toString()
              .toLowerCase()
              .indexOf(text.toLowerCase()) >= 0
          )
        }
      )
    }
  }
}
</script>

<style scoped>
.control input {
  height: 2em !important;
}
.taginput-container * {
  pointer-events: none;
}

#worldmap {
  animation: 1s ease-in-out;
  animation-name: map-in;
}
@keyframes map-in {
  0% {
    opacity: 0;
    transform: scale(0.1);
  }
  30% {
    opacity: 0;
    transform: scale(0.7);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
